export class PaymentMethod {
  static readonly CASH = 'CASH';
  static readonly CREDIT_CARD = 'CREDIT_CARD';
  static readonly TRANSFER = 'TRANSFER';
}
